/** GST number, billing address, and pincode required before estimate / PI download. */
export function isBuyerBillingCompleteForDocument(buyer) {
  if (!buyer || typeof buyer !== "object") return false;
  if (buyer.complete === true) return true;
  if (buyer.complete === false) return false;

  return (
    String(buyer.gst_number ?? "").trim() !== "" &&
    String(buyer.billing_address ?? "").trim() !== "" &&
    String(buyer.billing_pincode ?? "").trim() !== ""
  );
}

/** Billing address and pincode required before placing an order (GST optional). */
export function isBuyerProfileCompleteForPlaceOrder(buyer) {
  if (!buyer || typeof buyer !== "object") return false;
  if (buyer.profile_complete === true) return true;
  if (buyer.profile_complete === false) return false;

  return (
    String(buyer.billing_address ?? "").trim() !== "" &&
    String(buyer.billing_pincode ?? "").trim() !== ""
  );
}

export function formatBuyerBillingAddress(buyer) {
  if (!buyer || typeof buyer !== "object") return "";

  const parts = [
    buyer.billing_address,
    buyer.city,
    buyer.billing_pincode ? `Pincode: ${buyer.billing_pincode}` : null,
  ];

  return parts
    .map((part) => String(part ?? "").trim())
    .filter(Boolean)
    .join(", ");
}
